import { BaseEvent } from '@kiplin/web-common/event';

export type CurrentClientChangedEventData = {
  clientId: string;
};

export class CurrentClientChangedEvent extends BaseEvent<CurrentClientChangedEventData> {
  public static getKey(): string {
    return 'current-client-changed';
  }

  public constructor(init: CustomEventInit<CurrentClientChangedEventData>) {
    super(CurrentClientChangedEvent.getKey(), init);
  }
}
